/**
 * Created by alvinoktavianus on 5/18/17.
 */

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { useMokaOutletPropsFirst } from 'utils/formatter';
import Header from '../Header';
import styles from './ActiveOutlets.css';

class ActiveOutlets extends Component {
  renderActiveOutlets() {
    const { outlets, isMokaposUser } = this.props;
    return _.map(outlets, outlet => {
      const today = moment();
      if (moment(outlet.end_date).diff(today) > 0 || !isMokaposUser) {
        return (
          <div className={styles['mb-20px']} key={outlet.id}>
            <div className={styles['mb-10px']}>
              <p className={styles['outlet-name']}>
                <strong>{useMokaOutletPropsFirst(outlet, o => o.name)}</strong>
              </p>
            </div>

            <div>
              Expiration Date:{' '}
              {isMokaposUser ? (
                <strong>
                  {moment(outlet.end_date).format('DD MMMM YYYY')}
                </strong>
              ) : (
                'N/A'
              )}
            </div>
          </div>
        );
      }
    });
  }

  render() {
    const { showLoadingSpinnerPage } = this.props;
    return (
      !showLoadingSpinnerPage && (
        <div>
          <Header title="active outlets" />
          {this.renderActiveOutlets()}
        </div>
      )
    );
  }
}

function mapStateToProps(state) {
  const { outlets } = state.setting.billing;
  const { is_mokapos_user: isMokaposUser } = state.moka.user.business;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return { outlets, showLoadingSpinnerPage, isMokaposUser };
}

const connected = connect(mapStateToProps)(ActiveOutlets);

export default connected;
